<template>
  <g clip-path="url(#clip0_236_29216)">
    <path
      d="M14.3279 8.68701C14.4936 8.68701 14.6286 8.82139 14.6218 8.98694C14.5667 10.3284 14.1433 11.6309 13.3953 12.7504C12.5916 13.9532 11.4493 14.8906 10.1129 15.4442C8.77644 15.9978 7.30585 16.1426 5.88708 15.8604C4.46831 15.5782 3.16508 14.8816 2.14221 13.8588C1.11933 12.8359 0.422746 11.5327 0.140536 10.1139C-0.141675 8.69512 0.00316574 7.22453 0.556742 5.88807C1.11032 4.55162 2.04777 3.40934 3.25054 2.60567C4.37004 1.85765 5.6726 1.43424 7.01403 1.3792C7.17957 1.3724 7.31396 1.50736 7.31396 1.67305V8.38701C7.31396 8.55269 7.44827 8.68701 7.61396 8.68701H14.3279Z"
      fill="#C2C6CD"
    />
    <path
      d="M15.633 7.46633C15.7987 7.46633 15.9332 7.33208 15.9338 7.1664C15.9368 6.28157 15.9347 5.3113 15.6048 4.51503C15.2373 3.62766 14.6985 2.82137 14.0194 2.14221C13.3402 1.46304 12.5339 0.924303 11.6466 0.556742C10.8532 0.228106 10.1306 0.042069 9.3 0.00635204C9.13447 -0.000765719 9 0.134315 9 0.3V7.16633C9 7.33202 9.13431 7.46633 9.3 7.46633H15.633Z"
      fill="#C2C6CD"
    />
  </g>
  <defs>
    <clipPath id="clip0_236_29216">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</template>
